import React, { Component, useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Card,
  CardBody,
  CardHeader,
  CardSubtitle,
  CardText,
  CardTitle,
  Col,
  Collapse,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"

import classnames from "classnames"
import Applications from "./applications"
import Application from "services/applications/Application.service"
import Summary from "./Summary"

let appService = null

let plasticsUser = null

const tabs = props => {
  const [assigned, setassigned] = useState()
  const [mounted, setmounted] = useState(false)

  useEffect(() => {
    appService = new Application(props.user)

    plasticsUser = appService.getStrategy("officer")
    plasticsUser.getAssignedTo(props.user.id, 1, true).then(response => {
      if (response.status) {
        // filter by under review
        let allRecords = response.data.data

        // console.log("officer ",response)
        // allRecords.data = filtered
        setassigned(response.data)
        setmounted(true)
      }
    })
  }, [])

  const paginate = page => {
    plasticsUser.getAssignedTo(props.user.id, page, true).then(response => {
      if (response.status) {
        setassigned(response.data)
      }
    })
  }

  return (
    <Col>
      {/* <Row>
        Service Dashboards
        <a href="dashboard-officer-env-audit">1. Environmental Audit Service</a>
        <br></br>
      </Row>
      <hr></hr> */}
      <Card>
        <CardHeader>Assigned Applications</CardHeader>
        <CardBody>
          {mounted ? (
            <Row>
              <Col sm="12">
                <Applications
                  user={props.user}
                  data={assigned}
                  paginate={paginate}
                />
              </Col>
            </Row>
          ) : null}
        </CardBody>
      </Card>
    </Col>
  )
}

export default tabs
